import React from 'react';
import { openInNewTab } from '../../../util';
import { DownloadButton, DownloadButtonLabel } from './DownloadAttachmentButton.styles';

const DownloadAttachmentButton = (props) => {
  const downloadAttachment = (event) => {
    event.stopPropagation();
    openInNewTab(props.url);
  };

  return (
    <DownloadButton onClick={downloadAttachment} hoverIcon={'/images/arrows/download-arrow-blue.svg'}>
      <img alt="download" src="/images/arrows/download-arrow-gray.svg" />
      <DownloadButtonLabel>{props.label}</DownloadButtonLabel>
    </DownloadButton>
  );
};

export default DownloadAttachmentButton;
